module.exports = __webpack_public_path__ + "static/media/teen-burger-mobile-399_fr.4527d55e.jpg";